var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"unselected-indicator"},[_c('span',[_vm._v("Selecione um indicador acima antes de editar.")])])
}]

export { render, staticRenderFns }